// en-CA is YYYY-MM-DD, the same shape the backend uses for dates.
export const toISODate = (date) => date.toLocaleDateString('en-CA');

// The explicit time keeps a bare 'YYYY-MM-DD' from parsing as UTC midnight.
export const addDays = (iso, days) => {
  const date = new Date(`${iso}T00:00`);
  date.setDate(date.getDate() + days);
  return toISODate(date);
};

export const addMonths = (iso, months) => {
  const date = new Date(`${iso}T00:00`);
  date.setMonth(date.getMonth() + months);
  return toISODate(date);
};

// Monday of the week holding `date`: getDay() is Sunday-first, so shift by one.
export const mondayOf = (date) => addDays(toISODate(date), -((date.getDay() + 6) % 7));

export const firstOfMonth = (date) => toISODate(new Date(date.getFullYear(), date.getMonth(), 1));

export const lastOfMonth = (iso) => {
  const date = new Date(`${iso}T00:00`);
  return toISODate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
};

export const daysBetween = (start, end) => {
  const days = [];
  for (let day = start; day <= end; day = addDays(day, 1)) days.push(day);
  return days;
};

export const formatDate = (value, locale) => {
  // A bare 'YYYY-MM-DD' parses as UTC midnight, which renders as the day
  // before for anyone west of UTC; the explicit time makes it local.
  const local = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00` : value;
  const parsed = value ? new Date(local) : null;
  return parsed && !Number.isNaN(parsed.getTime())
    ? parsed.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
    : value || '-';
};
